namespace Gordic.Vyp.Lists {
    @Decorators.gcontent
    export class PrijemZasilekDleIDListPage extends GContentBase<VypListBasePage>
    {
        Settings: Wfl.Interface.GPrevzetiDleIdSettingsDto;

        onContentReady()
        {
            Wfl.ListAC.WflZasilkyListBaseAC.InitList(this);
            this.topActions.push(this.CreateActionPridat());
            this.specialActions.push(Wfl.ListAC.WflZasilkyListBaseAC.CreateActionPrevzitZasilky(this, true));
            VypListBasePage.CreateFrankovaniActions(this);
            VypListBasePage.CreateActionsTisk(this);
            Gordic.Wfl.ListAC.WflListBaseAC.CompleteMenu(this);
   
            this.defaultForm = $("<div>").appendTo(this.element).gform("createFrom", this.CreateDefaultForm());
            this.findFields().gfield("model", "apply", this.model).gfield("model", "validators", this.model);
            Lists.VypListBasePage.CreateGridZasilekVyp(this);
            Wfl.AC.WflBaseAC.ResolveInfo(this);
            this.findFields().gfield("model", "apply", this.model);
            this.model.PlnitTempTabulku = false                ;
            Gordic.Wfl.ListAC.WflListBaseAC.SetEnableActionsByData(this);
            this.ZadejZasilku();

            //this.LoadData();
            //this.model.PlnitTempTabulku = false;
        }

        CreateDefaultForm()
        {
            const that = this;
            const form = new Gordic.Forms.Form({ name: "Form", layoutDescriptor: "L1;M1;S1;" });
            form.addRow().addField("gcheck", "", {
                name: "ObraceneRazeni", model: "Settings.ObraceneRazeni=value", label: "jres:23900128", change: function (ev, obj)
                {
                    if (obj?.value)
                    {
                        that.Settings.ObraceneRazeni = obj?.value;
                    }
                } }, ); //RC 23900128 : Řadit obráceně
            return form;
        }

        ZadejZasilku()
        {
            // form
            const that = this;
            Wfl.Dialogs.HledaniZasilekDleIdDlg(this, { TypHledani: Wfl.Interface.TypHledaniZasilek.HledaniZasilekProPrevzeti }, Global.Enums.ModOtevreni.showModalWindow)
                .done(function (data)
                {
                    Wfl.AC.WflBaseAC.HideFlashByContent(that);
                    if (data)
                    {
                        that.ZpracujDataIdentifikace(data);
                    } 
                })
        }

        ZpracujDataIdentifikace(data: Wfl.Interface.GHledaniZasilekDleIdDto)
        {
            switch (data.typHledaniDle)
            {
                case Gordic.Wfl.Interface.TypHledaniDlePolozky.id_dorucenky:
                    this.ZpracujDataHledani(data);
                    break;
                case Gordic.Wfl.Interface.TypHledaniDlePolozky.ixs:
                    this.ZpracujDataHledani(data);
            }
        }

        ZpracujDataHledani(data: Wfl.Interface.GHledaniZasilekDleIdDto) {
            let that = this;

            this.call<string[]>("ZpracujDataHledani", { DataHledani: data, Dialog: that.Settings.DialogPrevzeti, RaditObracene: this.Settings.ObraceneRazeni })
                .done(function (IDs) {
                    if (IDs && that.ResultType == Gin.Interface.TypVysledkuOperace.Provedeno) {
                        if (IDs.length > 0) {
                            if (that.Settings.DialogPrevzeti) {
                                that.DoShowDialog(IDs);
                            }
                            else {
                                that.ResolveVyberZasilky(IDs, false);
                            }
                        }
                        else {
                            //let l_settings = that.VypraveniSettings;
                            //if (l_settings.frankovani_podaci_cislo)
                            //{
                            //    that.DoFrankovani(IDs[0])
                            //    Wfl.ListAC.WflListBaseAC.ResolveResultInfoContentu(that);
                            //}
                        }
                    }
                    else {
                        Wfl.AC.WflBaseAC.ShowFlashByContentInfo(that);
                        that.ZadejZasilku();
                    }
                })
                .fail(function (reason) {
                    that.dialogs.error(reason.statusText);
                });
        }

        //ZpracujDataDokumentu(data: Wfl.Interface.GHledaniZasilekDleIdDto) {
        //    let that = this;
        //    Wfl.Dialogs.VyberZasilkyDlg(that, { Data: data.dataZasilek! }, Global.Enums.ModOtevreni.showModalWindow)

        //        .done(function (res) {
        //            if (res)
        //            {


        //                that.LoadData();
        //                //that.load();
        //                that.dialogs.alert("jres:23900366") //RC 23900366 : Heslo bylo změněno.    

        //            }
        //        })
        //        .always(function () {
        //            that.endOperation();
        //        });
        //}

        DoFrankovani(sxs: string): JQuery.Promise<boolean>
        {
            let promis = $.Deferred<boolean>();
            Gordic.Wfl.Dialogs.ZasilkyInfoDlg(this, { Sxs: sxs, ModFormu: Wfl.Interface.ModFormuZasilkaInfo.balickovani })
                .done(function (ret) { promis.resolve(ret) })
                .fail(function (reason) { promis.resolve(true) });
            return promis.promise();
        }

        ResolveVyberZasilky(IDs: string[], prevzit: boolean)
        {
            let that = this;
            this.ZpracujeZasilky(IDs, prevzit)
                .done(function (retVal) {
                    if (retVal) {
                        if (that.Settings.Balickovani) {
                            var promises: JQuery.Promise<any>[] = [];
                            for (var i = 0; i < IDs.length; i++) {
                                promises.push(that.ShowDialogBalickovanmi(IDs[i]));
                            }
                            $.when.apply(null, promises).done(
                                function () {
                                    that.LoadData();

                                    //var l_ok = Gordic.Wfl.Commmon.GetPocetProvedenych(that.resultInfo) > 0;
                                    //Wfl.ListAC.WflListBaseAC.ResolveResultInfo(that, that.resultInfo);
                                    //promis.resolve(l_ok);
                                });
                        }
                        else {
                            that.LoadData();
                        }
                    }
                    else that.dialogs.warning("ERROR 23920061");
                });
        }

        DoShowDialog(Ids: string[])
        {
            //mel by se vrátit pouze jedno SXS
            let that = this;
            this.Poradi = 0;
            var promises: JQuery.Promise<any>[] = [];
            for (var i = 0; i < Ids.length; i++)
            {
                promises.push(that.ShowDialogZasilkaInfo(Ids[i]));                             
            }
            $.when.apply(null, promises).done(
                function (ok)
                {
                    if (ok)
                    {
                        that.ResolveVyberZasilky(Ids, true);
                    }
                    //var l_ok = Gordic.Wfl.Commmon.GetPocetProvedenych(that.resultInfo) > 0;
                    //Wfl.ListAC.WflListBaseAC.ResolveResultInfo(that, that.resultInfo);
                    //promis.resolve(l_ok);
                });
        }

        ShowDialogZasilkaInfo(sxs: string) : JQuery.Promise<boolean> 
        {
            let promis = $.Deferred<boolean>();
            Gordic.Wfl.Dialogs.ZasilkyInfoDlg(this, { Sxs: sxs, ModFormu: Wfl.Interface.ModFormuZasilkaInfo.prevzeti })
                .done(function (ret) { promis.resolve(ret) })
                .fail(function (reason) { promis.resolve(true) });                   

            return promis.promise();
        }

        ShowDialogBalickovanmi(sxs: string): JQuery.Promise<boolean> {
            let promis = $.Deferred<boolean>();
            Gordic.Wfl.Dialogs.ZasilkyInfoDlg(this, { Sxs: sxs, ModFormu: Wfl.Interface.ModFormuZasilkaInfo.balickovani })
                .done(function (ret) { promis.resolve(ret) })
                .fail(function (reason) { promis.resolve(true) });       
            return promis.promise();
        }

        ZpracujeZasilky(Ids: string[], prevzit: boolean) : JQuery.Promise<boolean> 
        {
            let that = this;
            let promis = $.Deferred<boolean>();
            if (prevzit)
            {
                this.call<boolean>("PrevzitZasilky", { Sxs: Ids[0] })
                    .done(function (Ok)
                    {
                        promis.resolve(Ok);
                    })
                    .fail(function (retVal) {
                        Wfl.ListAC.WflListBaseAC.ResolveFaildAkce(that, retVal.statusText);
                        promis.resolve(false);
                    })
            }
            else
            {
                this.call<string[]>("NastavVyberZasilky", { IDs: Ids })
                    .done(function () { promis.resolve(true); })
                    .fail(function (retVal) {
                        Wfl.ListAC.WflListBaseAC.ResolveFaildAkce(that, retVal.statusText);
                        promis.resolve(false);
                    })
            }
            return promis.promise();
        }

        LoadData()
        {
            const that = this;
            Gin.Globals.ShowWaitLoadData(this);
            return this.call<Gordic.Wfl.Interface.GSeznamZasilekDto[]>("LoadDataThis", { model: this.model, Prevzato: this.Settings.Prevzato, RaditObracene: this.Settings.ObraceneRazeni })
                .done(function (data)
                {
                    Gordic.Wfl.ListAC.WflListBaseAC.ResolveResultData(that, data);
                    Gordic.Wfl.ListAC.WflListBaseAC.SetEnableActionsByData(that);
                    Gordic.Wfl.AC.WflBaseAC.ResolveInfo(that).done(function ()
                    {
                        that.ZadejZasilku();
                        Gordic.Wfl.ListAC.WflListBaseAC.OznacRadkyDlePriznaku(that);
                    })                   
                })
                .always(function ()
                {
                    Gordic.Wfl.ListAC.WflListBaseAC.AfterLoadData(that);
                    Gordic.Wfl.ListAC.WflListBaseAC.SetActionEnabled(that, Globals.Enums.ActionsName.FrankovaniOffline, true);
                });
        }

        CreateActionPridat(): GAction
        {
            const that = this;
            var action = new GAction({
                name: Gordic.Gin.Icons.ActionEnum.pridat,
                icon: Gordic.Gin.Icons.ActionEnum.pridat,
                caption: "jres:23900157", //RC 23900157 : Přidat
                tooltip: "jres:23900157",
                groupName: Gin.Globals.Enums.ActionsGroupName.FavoriteAlwaysEnabled,
                run: function (ev, ctx) {
                    that.ZadejZasilku();
                }
            });
            return action;
        }

        ReloadData()
        {           
            this.LoadData();
        }
    }
}

